export const PRODUCT = 'PRIVATE PILOT VISUAL ATLAS™'

export const PRODUCT_TAGLINE = 'THE COMPLETE PRIVATE PILOT VISUAL TRAINING & STUDY SYSTEM'

/** Anchor id of the $27 purchase section */
export const OFFER_ANCHOR = '#offer'

export const CHECKOUT_URL = 'https://private-pilot-visual-atlas.impultienda.ar/checkout'

export const MOCKUP_IMAGE =
  'https://cdn.magicpatterns.com/uploads/4yUKQRHmvwK7mBzYqYe9hk/Diseno_sin_titulo-4.png'

export const SUPPORT_EMAIL = 'kitonline27@gmail.com'

export const PIXEL_ID = '1090388720291763'
